import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { GenericDocMessageTemplateContainer } from '../../../../../../models/aggregates/generic_doc';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { GenericDocMessageTemplateLineContainerModel } from '../../../../../../models/aggregates/generic_doc/generic-doc-message-template-line.model';
import { ApiVisa  } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({providedIn: 'root'})
export class GenericDocMessageTemplateLineService extends BaseApiTemplateService<GenericDocMessageTemplateLineContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.GENERIC_DOC_PREFIX + 'message-templates-lines/' + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_DOC_PREFIX + 'message-templates-lines/' + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }


  getFile(guid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.GENERIC_DOC_PREFIX + '/file/' + guid;
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}
